import React from 'react';
import { AttachmentsColumnsProps } from '../../../../../core/types/coreTypes';
import { useAppSelector } from '../../../../../store/hooks';
import { setJobAttachFilters } from '../../../../../store/slices/jobsSlice';
import { jobAttachmentsFiltersSelector } from '../../../../../store/selectors/jobsSelector';
import AttachmentColumns from '../../../../../common/components/attachments-table/AttachmentColumns';
import usePermission from '../../../../../permissions-handling/permissionHook';
import { PermissionEnum } from '../../../../../core/enums/dictionariesEnums';
import { useCoreAttachmentsColumns } from '../../../../../core/hooks/useCoreAttachmentsColumns';

const JobAttachmentsColumns: React.FC<AttachmentsColumnsProps> = ({
  isAll,
  checkAll,
  totalElements,
  indeterminate,
  disabledActions,
  readOnly,
}) => {
  const allowedManage = usePermission(PermissionEnum.JobEditFields);
  const attachFilters = useAppSelector(jobAttachmentsFiltersSelector);

  const {
    searchVl,
    pickerValue,
    setPickerValue,
    sortHandle,
    onChangeSearchHandle,
    searchPressHandle,
    pickerHandle,
  } = useCoreAttachmentsColumns(attachFilters, setJobAttachFilters);

  return (
    <AttachmentColumns
      allowedManage={!!allowedManage && !readOnly}
      disabledActions={disabledActions}
      isAll={isAll}
      indeterminate={indeterminate}
      checkAll={checkAll}
      totalElements={totalElements}
      sortHandle={sortHandle}
      onChangeSearchHandle={onChangeSearchHandle}
      searchPressHandle={searchPressHandle}
      searchVl={searchVl}
      tableFilters={attachFilters}
      pickerValue={pickerValue}
      setPickerValue={setPickerValue}
      pickerHandle={pickerHandle}
    />
  );
};

export default JobAttachmentsColumns;
